import { useLazyQuery } from '@apollo/client'
import { Button, Modal, Paper, Slide } from '@material-ui/core'
import KeyIcon from '@material-ui/icons/VpnKey'
import { useEffect } from 'react'

import { CHANNEL_API_KEYS } from '../../graphql/channelAPIKeys'
import { getDirection, getTranslate } from '../../localization'
import { ChannelAPIKeys } from '../../types/channelAPIKeys'
import ChannelAPIKeysList from '../UserAPIKeysList'
// import UserAPIKeyRowSkeleton from './UserAPIKeyRow.skeleton'
import useStyles from './index.styles'

interface ChannelAPIKeyModalProps {
  isOpen: boolean
  onClose: () => void
  channelID?: string
}

const ChannelAPIKeyModal: React.FC<ChannelAPIKeyModalProps> = ({
  isOpen,
  onClose,
  channelID
}) => {
  const classes = useStyles()
  const [getAPIKeys, { loading, data, refetch }] = useLazyQuery<{
    channelAPIKeys: ChannelAPIKeys[]
  }>(CHANNEL_API_KEYS)
  useEffect(() => {
    if (isOpen) getAPIKeys({ variables: { channelId: channelID } })
  }, [isOpen])
  return (
    <Modal
      dir={getDirection()}
      open={isOpen}
      onClose={onClose}
      className={classes.modal}>
      <Slide direction="down" in={isOpen}>
        <Paper className={classes.deletePaper}>
          <KeyIcon className={classes.deleteIcon} />
          <ChannelAPIKeysList
            refetch={refetch}
            data={data?.channelAPIKeys || []}
            loading={loading}
          />
          <div className={classes.buttonsContainer}>
            <Button
              variant="contained"
              color="primary"
              onClick={onClose}
              className={classes.deleteButton}>
              {getTranslate('Close')}
            </Button>
          </div>
        </Paper>
      </Slide>
    </Modal>
  )
}

export default ChannelAPIKeyModal
